import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/app/app/bil/[carId]/components/backButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarImages"] */ "/app/app/bil/[carId]/components/carImages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarPageContent"] */ "/app/app/bil/[carId]/components/carPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageWrapper"] */ "/app/components/styled-common/pageWrapper.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DepartmentThemeWrapper"] */ "/app/design-system/DepartmentThemeWrapper.tsx");
